export enum EnumEnseigne {
    'Pharmacie',
    'Matériel Médical',
    'Optique'
}